import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-page-card',
    templateUrl: './page-card.component.html',
    styleUrls: ['./page-card.component.scss'],
    standalone: true,
    imports: [ButtonModule],
})
export class PageCardComponent {
    @Input() hideCloseBtn: boolean = false;
    @Input() isCloseButtonDisabled: boolean = false;

    @Output() exit: EventEmitter<void> = new EventEmitter<void>();
}
